import { useMutation, useQuery } from "@tanstack/react-query";
import { queryClient } from "@/shared/services/queryClient";
import { expoStockApi } from "../services/expoStockApi";

export const useExpoStockEntries = (params?: { includeZeroBalance?: boolean; enabled?: boolean }) => {
  return useQuery({
    queryKey: ["expo-stock", "entries", params],
    queryFn: () => expoStockApi.getEntries(params),
    enabled: params?.enabled ?? true,
  });
};

export const useExpoStockMovements = (params?: { expoStockEntryId?: string; pendingOnly?: boolean }) => {
  return useQuery({
    queryKey: ["expo-stock", "movements", params],
    queryFn: () => expoStockApi.getMovements(params),
  });
};

export const useRequestMoveToExpo = () => {
  return useMutation({
    mutationFn: expoStockApi.requestMove,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["greenhouse-stock-available"] });
      queryClient.invalidateQueries({ queryKey: ["expo-stock"] });
    },
  });
};

export const useRequestReturnToGreenhouse = () => {
  return useMutation({
    mutationFn: expoStockApi.requestReturn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["greenhouse-stock-available"] });
      queryClient.invalidateQueries({ queryKey: ["expo-stock"] });
    },
  });
};

export const useApproveExpoMovement = () => {
  return useMutation({
    mutationFn: ({ id, decisionComment }: { id: string; decisionComment?: string }) =>
      expoStockApi.approveMovement(id, decisionComment),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["greenhouse-stock-available"] });
      queryClient.invalidateQueries({ queryKey: ["expo-stock"] });
    },
  });
};

export const useRejectExpoMovement = () => {
  return useMutation({
    mutationFn: ({ id, decisionComment }: { id: string; decisionComment: string }) =>
      expoStockApi.rejectMovement(id, decisionComment),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["expo-stock"] });
    },
  });
};
